import { AdminHelpComponent } from './components/admin/admin-help/admin-help.component';
import { AdminFederationsComponent } from './components/admin/admin-federations/admin-federations.component';
import { RatingComponent } from './components/rating/rating.component';
import { AdminSessionsComponent } from './components/admin/admin-sessions/admin-sessions.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfessionalSpaceComponent } from './auth/professional-space/professional-space.component';
import { SignInUserComponent } from './auth/sign-in-user/sign-in-user.component';
import { AdminClubDetailsComponent } from './components/admin/admin-club-details/admin-club-details.component';
import { AdminClubsComponent } from './components/admin/admin-clubs/admin-clubs.component';
import { AdminCounterComponent } from './components/admin/admin-counter/admin-counter.component';
import { AdminDiscountComponent } from './components/admin/admin-discount/admin-discount.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { AdminModificationsComponent } from './components/admin/admin-modifications/admin-modifications.component';
import { AdminOfferPriorityComponent } from './components/admin/admin-offer-priority/admin-offer-priority.component';
import { AdminOfferComponent } from './components/admin/admin-offer/admin-offer.component';
import { AdminParametersComponent } from './components/admin/admin-parameters/admin-parameters.component';
import { AdminPaymentsComponent } from './components/admin/admin-payments/admin-payments.component';
import { AdminPlanningComponent } from './components/admin/admin-planning/admin-planning.component';
import { AdminPracticePlaceComponent } from './components/admin/admin-practice-place/admin-practice-place.component';
import { AdminResourceComponent } from './components/admin/admin-resource/admin-resource.component';
import { AdminStructureAddComponent } from './components/admin/admin-structure-add/admin-structure-add.component';
import { AdminStructureDetailsComponent } from './components/admin/admin-structure-details/admin-structure-details.component';
import { AdminStructureComponent } from './components/admin/admin-structure/admin-structure.component';
import { AdminTagsComponent } from './components/admin/admin-tags/admin-tags.component';
import { AdminUsedRessourceComponent } from './components/admin/admin-used-ressource/admin-used-ressource.component';
import { AdminComponent } from './components/admin/admin.component';
import { ErrorComponent } from './components/error/error.component';
import { HomeComponent } from './components/home/home.component';
import { OfferDetailsComponent } from './components/home/offer-details/offer-details.component';
import { OfferHomeComponent } from './components/home/offer-home/offer-home.component';
import { IframeClubComponent } from './components/iframe-club/iframe-club.component';
import { MyPersonalInformationComponent } from './components/my-personal-information/my-personal-information.component';
import { MyShoppingBagComponent } from './components/my-shopping-bag/my-shopping-bag.component';
import { MyTraineesComponent } from './components/my-trainees/my-trainees.component';
import { MyWishComponent } from './components/my-wish/my-wish.component';
import { SessionBookedHistoryComponent } from './components/session-booked-history/session-booked-history.component';
import { AdminGuard } from './shared/guard/admin.guard';
import { AuthGuard } from './shared/guard/auth.guard';
import { RoleOfUserGuard } from './shared/guard/role-of-user.guard';
import { ShowIconsGuard } from './shared/guard/show-icons.guard';
import { UnauthGuard } from './shared/guard/unauth.guard';
import { UserWelcomeGuard } from './shared/guard/user-welcome.guard';
import { AdminReportsComponent } from './components/admin/admin-reports/admin-reports.component';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { ChangePwdGuard } from './shared/guard/change-pwd.guard';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { AdminOffersComponent } from './components/admin/admin-offers/admin-offers.component';


const routes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard],
    data: { application: 'admin' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard],
        component: AdminHomeComponent
      },
      {
        path: 'offers',
        component: AdminOffersComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, RoleOfUserGuard, ShowIconsGuard]
      },
      {
        path: 'clubs',
        component: AdminClubsComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'club-details',
        component: AdminClubDetailsComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'structure',
        component: AdminStructureComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'structure/new',
        component: AdminStructureAddComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'structure-details',
        component: AdminStructureDetailsComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'my-club',
        component: AdminClubDetailsComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'practice-place',
        component: AdminPracticePlaceComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'offer-priority',
        component: AdminOfferPriorityComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'discount',
        component: AdminDiscountComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'resource',
        component: AdminResourceComponent,
        data: { application: 'admin' },

        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'counter',
        component: AdminCounterComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'planning',
        component: AdminPlanningComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'tags',
        component: AdminTagsComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'payments',
        component: AdminPaymentsComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'used-ressources',
        component: AdminUsedRessourceComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'modifications',
        component: AdminModificationsComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'parameters',
        component: AdminParametersComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'sessions',
        component: AdminSessionsComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'federations',
        component: AdminFederationsComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'reports',
        component: AdminReportsComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      },
      {
        path: 'help',
        component: AdminHelpComponent,
        data: { application: 'admin' },
        canActivate: [AuthGuard, AdminGuard, UserWelcomeGuard, ShowIconsGuard]
      }
    ]
  },
  {
    path: 'iframe',
    component: IframeClubComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [UserWelcomeGuard, ShowIconsGuard],
    data: { application: 'user' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [UserWelcomeGuard, ShowIconsGuard],
        component: OfferHomeComponent,
        data: { application: 'user' },

      },
      {
        path: 'sign-in',
        canActivate: [UnauthGuard, UserWelcomeGuard, ShowIconsGuard],
        component: SignInUserComponent,
        data: { application: 'user' },

      },
      {
        path: 'sign-up',
        canActivate: [UnauthGuard, UserWelcomeGuard, ShowIconsGuard],
        component: SignUpComponent,
        data: { application: 'user' },
      },
      {
        path: 'forgot-password', component: ForgotPasswordComponent,
        canActivate: [UnauthGuard],
        data: { title: 'auth.forgotPassword' }
      },
      {
        path: 'change-password', component: ChangePasswordComponent,
        canActivate: [ChangePwdGuard],
        data: { title: 'auth.changePassword.title' }
      },
      {
        path: 'welcome', component: ChangePasswordComponent,
        canActivate: [ChangePwdGuard],
        data: { title: 'auth.changePassword.title' }
      },
      {
        path: 'my-shopping-bag',
        canActivate: [AuthGuard, UserWelcomeGuard, ShowIconsGuard],
        component: MyShoppingBagComponent,
        data: { application: 'user' },

      },
      // {
      //   path: 'my-wishes',
      //   canActivate: [AuthGuard, UserWelcomeGuard, ShowIconsGuard],
      //   component: MyWishComponent,
      //   data: { application: 'user' },

      // },
      {
        path: 'offer',
        canActivate: [UserWelcomeGuard, ShowIconsGuard],
        component: OfferDetailsComponent,
        data: { application: 'user' },

      },
      {
        path: 'purchases-history',
        canActivate: [AuthGuard, UserWelcomeGuard, ShowIconsGuard],
        component: SessionBookedHistoryComponent,
        data: { application: 'user' },
      },
      {
        path: 'my-trainees',
        canActivate: [AuthGuard, UserWelcomeGuard, ShowIconsGuard],
        component: MyTraineesComponent,
        data: { application: 'user' },
      },
      {
        path: 'personal-information',
        canActivate: [AuthGuard, UserWelcomeGuard, ShowIconsGuard],
        component: MyPersonalInformationComponent,
        data: { application: 'user' },
      },
    ]
  },
  {
    path: 'espace-pro',
    component: ProfessionalSpaceComponent,
    canActivate: [UnauthGuard]
  },
  {
    path: 'rating',
    component: RatingComponent
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: '**',
    // canActivate: [UserWelcomeGuard, ShowIconsGuard],
    // component: ErrorComponent,
    pathMatch: 'full',
    redirectTo: 'home'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
